import React from 'react';
import styled from 'styled-components';

import { Accordion, SvgIcon } from '@make-software/cspr-ui';
import { Table, BodyText } from '@block-explorer/ui';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: 4,
}));

const CollapsibleRow = styled.div(({ theme }) =>
  theme.withMedia({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    height: 40,
    background: theme.styleguideColors.fillSecondary,
    '&:hover': {
      span: {
        color: theme.styleguideColors.contentRed,
      },
    },
  })
);

const StyledIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.contentTertiary,
    [`${CollapsibleRow}:hover &`]: {
      color: theme.styleguideColors.contentRed,
    },
  })
);

export const AccountInfoAccordion = ({ children, ...props }: any) => {
  return (
    <StyledAccordion {...props} style={{}}>
      {({ isOpen }) => (
        <CollapsibleRow>
          <BodyText size={1}>{children}</BodyText>
          <StyledIcon src="assets/icons/ic-arrow-down.svg" rotate={isOpen} />
        </CollapsibleRow>
      )}
    </StyledAccordion>
  );
};

export const AccountInfoTable = styled(Table)(({ theme }) =>
  theme.withMedia({
    marginBottom: 16,
  })
);
